<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รายการใบแจ้งหนี้</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการใบแจ้งหนี้และตรวจสอบสถานะการชำระเงิน</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <button (click)="navigateToCreate()"
        class="px-5 py-3 bg-amber-400 dark:bg-amber-500 text-white rounded-xl shadow-lg shadow-amber-200 dark:shadow-none hover:bg-amber-500 dark:hover:bg-amber-600 hover:-translate-y-0.5 transition-all duration-300 font-bold flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons">add_circle</span>
        <span>สร้างใบแจ้งหนี้</span>
      </button>
      <button (click)="toggleDashboard()"
        class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2 h-[46px]"
        [title]="showDashboard ? 'ซ่อนแดชบอร์ด' : 'แสดงแดชบอร์ด'">
        <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
        <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนแดชบอร์ด' : 'แสดงแดชบอร์ด' }}</span>
      </button>

      <!-- Date Filter (same pattern as transaction-parking) -->
      <div
        class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-50 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
        <span class="material-icons text-slate-400 dark:text-slate-500 text-xl">calendar_today</span>

        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
            <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>

        <span class="text-slate-300 dark:text-slate-600">-</span>

        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
            <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>

      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button (click)="onRefresh()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Collapsible Dashboard -->
  <div class="overflow-hidden transition-all duration-500 ease-in-out"
    [style.max-height]="showDashboard ? '3200px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2rem' : '0'">
    <p class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-4">
      สรุปตามช่วงวันที่: <span class="text-slate-600 dark:text-slate-300">{{ tableDateRangeLabel }}</span>
    </p>

    <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div *ngFor="let stat of dashboardStats; let i = index"
        class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
        [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">
        <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
          [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
            [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
            <span class="material-icons text-2xl">{{ stat.icon }}</span>
          </div>
        </div>
        <div class="relative z-10">
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}</div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-2">
      <!-- Trend Chart -->
      <div class="lg:col-span-2 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-6 relative overflow-hidden">
        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
          <div>
            <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
              แนวโน้มใบแจ้งหนี้
              <span class="text-sm font-medium text-slate-500 dark:text-slate-400 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                {{ chartTotalCount }} รายการ
              </span>
            </h3>
            <p class="text-xs text-slate-400 dark:text-slate-500 mt-1">กรองช่วงเวลาแยกจากวันที่ในตาราง</p>
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <div class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1">
              <button (click)="setChartType('line')"
                class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                [ngClass]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-amber-600 shadow-sm' : 'text-slate-400'">
                <span class="material-icons text-sm align-middle">show_chart</span>
              </button>
              <button (click)="setChartType('bar')"
                class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                [ngClass]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-amber-600 shadow-sm' : 'text-slate-400'">
                <span class="material-icons text-sm align-middle">bar_chart</span>
              </button>
            </div>
            <div class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1">
              <button (click)="setChartMode('daily')"
                class="px-2 py-1 text-xs font-bold rounded-md transition-all"
                [ngClass]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-400'">
                รายวัน
              </button>
              <button (click)="setChartMode('monthly')"
                class="px-2 py-1 text-xs font-bold rounded-md transition-all"
                [ngClass]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-400'">
                รายเดือน
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="chartMode === 'monthly'" class="flex flex-wrap items-center gap-2 mb-4">
          <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
            class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1 text-xs font-bold text-slate-600 dark:text-slate-300">
          <span class="text-slate-400">-</span>
          <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
            class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1 text-xs font-bold text-slate-600 dark:text-slate-300">
        </div>

        <div class="relative w-full h-40" [class.opacity-50]="isTrendLoading">
          <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
            <defs>
              <linearGradient id="invoiceGradientArea" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.3" />
                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
              </linearGradient>
            </defs>
            <g class="text-slate-100 dark:text-slate-800">
              <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
              <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
              <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
              <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
            </g>
            <g *ngIf="chartType === 'line'">
              <polygon [attr.points]="currentMonthAreaPoints" fill="url(#invoiceGradientArea)" />
              <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <g *ngIf="chartType === 'bar'">
              <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 1.5" [attr.y]="point.y" width="3"
                [attr.height]="100 - point.y" [attr.fill]="point.color" rx="0.5">
                <title>{{ point.label }}: {{ point.value }}</title>
              </rect>
            </g>
          </svg>
          <div class="absolute right-0 top-0 bottom-0 flex flex-col justify-between text-[8px] text-slate-400 font-bold pointer-events-none py-1 pr-1">
            <span>{{ yAxisLabels[4] }}</span>
            <span>{{ yAxisLabels[3] }}</span>
            <span>{{ yAxisLabels[2] }}</span>
            <span>{{ yAxisLabels[1] }}</span>
            <span>{{ yAxisLabels[0] }}</span>
          </div>
        </div>
        <div class="flex justify-between px-1 mt-2 border-t border-slate-100 dark:border-slate-700 pt-2 text-[10px] font-bold text-slate-500 dark:text-slate-400">
          <div *ngFor="let dot of currentMonthDots; let idx = index" class="text-center w-8">
            <span *ngIf="(currentMonthDots.length <= 8) || (idx % 3 === 0) || idx === 0 || idx === currentMonthDots.length - 1">
              {{ dot.label }}
            </span>
          </div>
        </div>
      </div>

      <!-- Recent Activity -->
      <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-6">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-4 flex items-center gap-2">
          <span class="material-icons text-amber-500">history</span>
          กิจกรรมล่าสุด
        </h3>
        <div class="relative">
          <div class="absolute left-4 top-2 bottom-2 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
          <div class="space-y-4 relative">
            <div *ngFor="let item of recentActivity" class="flex items-start gap-3 group">
              <div class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold shadow-md ring-4 ring-white dark:ring-slate-800 z-10"
                [ngClass]="item.color">
                {{ item.initial }}
              </div>
              <div class="flex-1 pt-0.5 min-w-0">
                <div class="flex justify-between items-start gap-2">
                  <h5 class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate group-hover:text-amber-500 transition-colors">
                    {{ item.name }}
                  </h5>
                  <span class="text-[10px] font-bold text-slate-400 bg-slate-50 dark:bg-slate-900 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-700 whitespace-nowrap">
                    {{ item.timeAgo }}
                  </span>
                </div>
                <p class="text-xs text-slate-500 dark:text-slate-400 truncate mt-0.5">{{ item.info }}</p>
              </div>
            </div>
            <div *ngIf="recentActivity.length === 0" class="text-center text-slate-400 py-8">
              <span class="material-icons text-3xl mb-2 opacity-40">history</span>
              <p class="text-sm font-bold">ไม่มีกิจกรรมล่าสุด</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Card -->
  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.2s;">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">receipt_long</span>
        รายการใบแจ้งหนี้
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>

      <div class="flex flex-col md:flex-row gap-3 w-full xl:flex-1 xl:min-w-0 xl:justify-end">
        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm">
          <button (click)="selectStatus(1)"
            [class]="filterStatus === 1 ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400'"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200">รอชำระ</button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button (click)="selectStatus(2)"
            [class]="filterStatus === 2 ? 'bg-white dark:bg-slate-700 text-green-600 dark:text-green-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-green-600 dark:hover:text-green-400'"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200">ชำระแล้ว</button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button (click)="selectStatus('all')"
            [class]="filterStatus === 'all' ? 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200">ทั้งหมด</button>
        </div>

        <div class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full md:flex-1 md:min-w-[360px] relative z-30 h-[46px]">
          <div class="relative min-w-[120px] shrink-0 border-r border-slate-200 dark:border-slate-700 h-full">
            <button (click)="toggleSearchTypeDropdown()"
              class="w-full pl-4 pr-3 h-full text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
            </button>
            <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
              (click)="toggleSearchTypeDropdown()"></button>
            <div *ngIf="isSearchTypeDropdownOpen"
              class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden">
              <button (click)="selectSearchType('customerName')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400">person</span>
                ชื่อลูกค้า
              </button>
              <button (click)="selectSearchType('invoiceNo')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400">receipt</span>
                เลขที่ใบแจ้งหนี้
              </button>
            </div>
          </div>
          <div class="relative flex-1 h-full">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-xl">search</span>
            <input type="text" [placeholder]="searchPlaceholder" [(ngModel)]="searchText" (keyup.enter)="onClickSearch()"
              class="w-full pl-10 pr-4 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600">
          </div>
          <button (click)="onClickSearch()"
            class="shrink-0 px-4 h-full bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all mr-1">
            ค้นหา
          </button>
        </div>

        <button (click)="toggleTableFilters()"
          class="p-2.5 bg-slate-50 dark:bg-slate-900 text-slate-500 dark:text-slate-400 rounded-xl border border-slate-200 dark:border-slate-700 hover:text-amber-500 hover:border-amber-300 transition-all flex items-center justify-center h-[46px] w-[46px]"
          title="ตัวกรองเพิ่มเติม">
          <span class="material-icons">filter_list</span>
        </button>
      </div>
    </div>

    <div *ngIf="showTableFilters"
      class="px-6 pb-6 border-b border-slate-100 dark:border-slate-700 grid grid-cols-1 md:grid-cols-2 gap-4 animate-fade-in">
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ยอดรวมขั้นต่ำ (บาท)</label>
        <div class="relative h-[46px]">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-xs">฿</span>
          <input type="number" placeholder="0.00" [(ngModel)]="filterMinTotal" (keyup)="onFilterChange()"
            class="w-full pl-7 pr-3 h-full bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30">
        </div>
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ยอดค้างจ่ายขั้นต่ำ (บาท)</label>
        <div class="relative h-[46px]">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-xs">฿</span>
          <input type="number" placeholder="0.00" [(ngModel)]="filterMinRemaining" (keyup)="onFilterChange()"
            class="w-full pl-7 pr-3 h-full bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30">
        </div>
      </div>
    </div>

    <div class="overflow-x-auto h-[600px] relative custom-scrollbar" [class.opacity-50]="isLoading">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr>
            <th (click)="sortData('invoiceNo')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center gap-1">
                เลขใบแจ้งหนี้
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'invoiceNo'">
                  {{ sortColumn === 'invoiceNo' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('customerName')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center gap-1">
                ลูกค้า / บริษัท
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'customerName'">
                  {{ sortColumn === 'customerName' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('total')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-right whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center justify-end gap-1">
                จำนวนเงินรวม
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'total'">
                  {{ sortColumn === 'total' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('remaining')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-right whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center justify-end gap-1">
                ยอดคงค้าง
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'remaining'">
                  {{ sortColumn === 'remaining' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('invoiceDate')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center justify-center gap-1">
                วันที่ออกเอกสาร
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'invoiceDate'">
                  {{ sortColumn === 'invoiceDate' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('status')" class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center whitespace-nowrap cursor-pointer hover:text-amber-500 group">
              <div class="flex items-center justify-center gap-1">
                สถานะ
                <span class="material-icons text-sm opacity-0 group-hover:opacity-100 transition-all"
                  [class.opacity-100]="sortColumn === 'status'">
                  {{ sortColumn === 'status' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <ng-container *ngFor="let inv of invoices; let i = index">
            <tr (click)="toggleRow(inv.id, $event)"
              class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200 cursor-pointer"
              [ngClass]="{ 'bg-amber-50/30 dark:bg-amber-900/10': expandedInvoiceId() === inv.id }"
              [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">
              <td class="p-5 font-mono text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors whitespace-nowrap">
                <div class="flex items-center gap-2">
                  <span class="material-icons text-slate-400 group-hover:text-amber-500 transition-transform duration-200 text-sm"
                    [class.rotate-90]="expandedInvoiceId() === inv.id">chevron_right</span>
                  <span>{{ inv.invoiceNo || inv.id }}</span>
                </div>
              </td>
              <td class="p-5 whitespace-nowrap">
                <div class="flex items-center gap-3">
                  <div class="flex-shrink-0 w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-slate-500 dark:text-slate-400 font-bold text-xs shadow-sm group-hover:bg-white dark:group-hover:bg-slate-800 group-hover:text-amber-500 transition-colors">
                    {{ (inv.customerName || 'U')[0] }}
                  </div>
                  <div class="flex flex-col min-w-0">
                    <span class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate max-w-[180px]" [title]="inv.customerName">{{ inv.customerName }}</span>
                    <span class="text-xs text-slate-400 dark:text-slate-500">{{ inv.siteName }}</span>
                  </div>
                </div>
              </td>
              <td class="p-5 text-right font-bold text-slate-700 dark:text-slate-200 whitespace-nowrap">
                {{ (inv.fee + inv.vat) | number:'1.2-2' }}
              </td>
              <td class="p-5 text-right font-bold whitespace-nowrap">
                <span [class.text-rose-600]="inv.status !== 2 && inv.status !== 3"
                  [class.text-green-600]="inv.status === 2 || inv.status === 3">
                  {{ ((inv.status !== 2 && inv.status !== 3) ? (inv.fee + inv.vat) : 0) | number:'1.2-2' }}
                </span>
              </td>
              <td class="p-5 text-center text-sm text-slate-500 dark:text-slate-400 font-medium whitespace-nowrap">
                {{ formatDateDisplay(inv.invoiceDate) }}
              </td>
              <td class="p-5 text-center">
                <span *ngIf="getStatusConfig(getDisplayStatus(inv)) as statusConfig"
                  class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm gap-1"
                  [ngClass]="statusConfig.bsClass">
                  <span class="w-1.5 h-1.5 rounded-full bg-current opacity-70"></span>
                  {{ statusConfig.label }}
                </span>
              </td>
              <td class="p-5 text-center whitespace-nowrap" (click)="$event.stopPropagation()">
                <div class="inline-flex items-center gap-2">
                  <button (click)="navigateToDetail(inv.id)"
                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 dark:hover:bg-blue-600 hover:text-white transition-all shadow-sm"
                    title="ดูรายละเอียด">
                    <span class="material-icons text-[18px]">visibility</span>
                  </button>
                  <button *ngIf="inv.status === 1" (click)="navigateToEdit(inv.id)"
                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 hover:bg-amber-500 dark:hover:bg-amber-600 hover:text-white transition-all shadow-sm"
                    title="แก้ไขรายละเอียด">
                    <span class="material-icons text-[18px]">edit</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="expandedInvoiceId() === inv.id" class="bg-slate-50/50 dark:bg-slate-900/50 animate-fade-in">
              <td colspan="7" class="px-6 py-5 border-b border-slate-100 dark:border-slate-700">
                <div class="flex flex-col gap-4">
                  <div class="flex justify-between items-start border-b border-slate-100 dark:border-slate-700 pb-3">
                    <div>
                      <h4 class="text-sm font-bold text-slate-800 dark:text-slate-200">{{ inv.customerName }}</h4>
                      <p class="text-xs text-slate-400 mt-1">ผู้ทำรายการ: {{ inv.createBy || 'System Admin' }}</p>
                    </div>
                    <div class="text-right">
                      <span class="text-xs font-bold text-slate-400">วันครบกำหนดชำระ</span>
                      <p class="text-sm font-bold text-rose-500 mt-0.5">{{ formatDateDisplay(inv.dueDate) }}</p>
                    </div>
                  </div>
                  <div class="text-sm">
                    <span class="text-slate-400 font-bold block text-xs uppercase tracking-wider mb-1">หมายเหตุ</span>
                    <span class="text-slate-700 dark:text-slate-300">{{ inv.remark || 'ไม่มีหมายเหตุประกอบรายการ' }}</span>
                  </div>
                  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
                    <div>
                      <span class="text-slate-400 font-bold block text-xs uppercase tracking-wider mb-1">ยอดก่อนภาษี</span>
                      <span class="text-slate-700 dark:text-slate-200 font-bold">{{ inv.fee | number:'1.2-2' }} บาท</span>
                    </div>
                    <div>
                      <span class="text-slate-400 font-bold block text-xs uppercase tracking-wider mb-1">ภาษี {{ vatSetting.rateLabel() }}%</span>
                      <span class="text-slate-700 dark:text-slate-200 font-bold">{{ inv.vat | number:'1.2-2' }} บาท</span>
                    </div>
                    <div>
                      <span class="text-slate-400 font-bold block text-xs uppercase tracking-wider mb-1">ยอดรวมสุทธิ</span>
                      <span class="text-slate-800 dark:text-slate-100 font-black">{{ (inv.fee + inv.vat) | number:'1.2-2' }} บาท</span>
                    </div>
                  </div>
                  <div class="flex justify-end border-t border-slate-100 dark:border-slate-700 pt-4">
                    <button *ngIf="inv.status === 1" (click)="navigateToEdit(inv.id)"
                      class="px-4 py-2 bg-amber-400 hover:bg-amber-500 text-white rounded-xl text-sm font-bold flex items-center gap-1.5 transition-all">
                      <span class="material-icons text-sm">edit</span>
                      แก้ไขรายละเอียด
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="invoices.length === 0 && !isLoading">
            <td colspan="7" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                  <span class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูลใบแจ้งหนี้</h3>
                <span class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
          class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors">
          <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="page === currentPage ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage >= totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-invoice-detail *ngIf="isModalDetailOpen" [id]="selectedInvoiceId" (close)="closeDetailModal()"
  (save)="saveDetailModal()">
</app-modal-invoice-detail>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
